import i18n from '@/plugins/i18n'
import type { NavItems } from '@/interfaces/nav'

export function useInterviewerNavigation() {
  const navItems = computed<NavItems>(() => [
    {
      title: i18n.global.t('nav_titles.adviser_dashboard'),
      to: { name: 'interviewer-days.list' },
      icon: 'mdi-calendar-month',
    },
  ])

  return {
    navItems,
  }
}
